/**
 * Vertraege rund um Job-Queue und Aufruf-Protokoll (AP2.T2.5).
 *
 * Backend und Frontend teilen sich diese Definitionen: Der Worker meldet
 * Statusaenderungen ueber SSE, und die Ansicht "letzte KI-Aufrufe" unter
 * Einstellungen liest das Protokoll ueber die HTTP-API.
 */
/* -------------------------------------------------------------------------
 * Aufruf-Protokoll (llm_call_log)
 * ---------------------------------------------------------------------- */
/** Zustaende eines protokollierten Aufrufs - identisch zur CHECK-Regel der Tabelle. */
export const LLM_CALL_STATUSES = ['pending', 'success', 'error'];
export function isLlmCallStatus(value) {
    return typeof value === 'string' && LLM_CALL_STATUSES.includes(value);
}
/**
 * Markierung, die eine gekuerzte Nutzlast im Protokoll traegt. Wer sie in
 * Prompt oder Antwort sieht, weiss: hier fehlt etwas, und zwar absichtlich.
 */
export const LLM_LOG_TRUNCATION_MARKER = '[gekuerzt]';
/* -------------------------------------------------------------------------
 * Job-Queue
 * ---------------------------------------------------------------------- */
/**
 * Zustaende eines Jobs.
 *
 * `dead` ist der Dead-Letter-Zustand: entweder war der Fehler nicht
 * wiederholbar, oder `max_attempts` ist erschoepft. `failed` stammt aus dem
 * Schema-Skelett von AP1 und wird vom Worker **nicht** verwendet - ein Job ist
 * entweder wieder eingeplant (`queued`) oder endgueltig `dead`.
 */
export const JOB_STATUSES = ['queued', 'running', 'done', 'failed', 'dead'];
export function isJobStatus(value) {
    return typeof value === 'string' && JOB_STATUSES.includes(value);
}
export function isJobEvent(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const candidate = value;
    return (typeof candidate['jobId'] === 'string' &&
        typeof candidate['jobType'] === 'string' &&
        isJobStatus(candidate['status']) &&
        typeof candidate['at'] === 'string');
}
/** Name des SSE-Ereignisses, unter dem Statusaenderungen ankommen. */
export const JOB_EVENT_NAME = 'job';
//# sourceMappingURL=observability.js.map